export const getReqUrl = (apiEndpoint, path) => `${apiEndpoint}${path}`;

export const genericErrorMessage = 'Network response was not ok';

export const handleDataPlatformError = async (res) => {
  let errorMessage = genericErrorMessage;
  const statusCode = res.status;
  try {
    const jsonResponse = await res.json();
    if (jsonResponse.errors?.length) {
      errorMessage = jsonResponse.errors.toString();
    }
  } catch (error) {
    errorMessage = error.message;
  }
  const error = new Error(errorMessage);
  error.code = statusCode;

  console.log(statusCode);

  if (statusCode === 401) {
    const redirectParam = new URLSearchParams({
      redirectUri: window.location.href
    });
    window.location.replace(
      `${process.env.REACT_APP_SIGN_IN_URL}?${redirectParam.toString()}`
    );
  }

  throw error;
};
